import { Controller } from "@hotwired/stimulus"

// ScrollReveal — entrada em cascata da landing: descendentes com [data-sr]
// ganham .sr-in quando entram na viewport (CSS faz o fade+subida; o atraso
// escalonado vem de style="--d: .2s" em cada elemento). Elementos com
// [data-sr-lit] ganham .lit (o CTA final "acende": feixes, cintilo).
//
// Com prefers-reduced-motion tudo aparece pronto, sem animação (o CSS também
// zera as transições; aqui evitamos até o observer).
//
//   <div data-controller="scroll-reveal">
//     <h2 data-sr>…</h2>
//     <p data-sr style="--d:.1s">…</p>
//     <section data-sr-lit>…</section>
//   </div>
export default class extends Controller {
  connect() {
    const items = this.element.querySelectorAll("[data-sr]")
    const lits  = this.element.querySelectorAll("[data-sr-lit]")
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    if (reduce || !("IntersectionObserver" in window)) {
      items.forEach((el) => el.classList.add("sr-in"))
      lits.forEach((el) => el.classList.add("lit"))
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add(entry.target.hasAttribute("data-sr-lit") ? "lit" : "sr-in")
        this.observer.unobserve(entry.target)
      })
    }, { threshold: 0.25 })

    items.forEach((el) => this.observer.observe(el))
    lits.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
